import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
const TIMEOUT = import.meta.env.VITE_AXIOS_TIMEOUT

const errorQueue = []
const MAX_ERRORS = 50

const TRACE_ID_KEY = 'trace_id'

export function getOrCreateTraceId() {
  let traceId = sessionStorage.getItem(TRACE_ID_KEY)

  if (!traceId) {
    traceId = uuidv4()
    sessionStorage.setItem(TRACE_ID_KEY, traceId)
  }

  return traceId
}

function mountHeaders(config) {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token
  }

  config.headers['X-Trace-Id'] = getOrCreateTraceId()

  const sessionId = sessionStorage.getItem('session_id')
  if (sessionId) {
    config.headers['X-Session-ID'] = sessionId
  }

  const lang = localStorage.getItem('lang', 'pt-BR')
  if (lang === 'en') {
    config.headers['Accept-Language'] = 'en'
  } else {
    config.headers['Accept-Language'] = 'pt-BR'
  }
  return config
}

axios.interceptors.request.use(config => {
  config.baseURL = (import.meta.env.VITE_MOBILE_API || '').trim()
  config.headers['Content-Type'] = 'application/json'

  config = mountHeaders(config)
  config.timeout = TIMEOUT
  return config
})

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    // If we get a 401, it means the token is invalid or expired
    // We should clear it to allow public access to some endpoints
    if (error.response?.status === 401) {
      console.warn('[API] 401 Unauthorized - clearing invalid auth data')
      localStorage.removeItem('token')
      sessionStorage.removeItem('session_id')
      // Add flag to skip automatic redirection in handlers
      error.skipRedirect = true
    }

    const isUnrecoverable =
      error.response?.status >= 500 ||
      !navigator.onLine ||
      error.code === 'ECONNABORTED' ||
      error.code === 'ERR_NETWORK'
    if (isUnrecoverable) {
      errorQueue.push({
        timestamp: new Date().toISOString(),
        message: error.message,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          data: error.config?.data
        },
        status: error.response?.status,
        stack: error.stack
      })

      if (errorQueue.length > MAX_ERRORS) {
        errorQueue.shift()
      }

      localStorage.setItem('errorQueue', JSON.stringify(errorQueue))
    }
    return Promise.reject(error)
  }
)
function clearAuthUserData() {
  const headers = ['Authorization', 'X-Session-ID', 'X-Trace-ID', 'withCredentials']
  for (const elem of headers) {
    delete API.defaults.headers.common[elem]
  }

  const localStorageKeys = ['fingerPrintUUID', 'lang', 'token', 'point_name', 'terminal_token']
  for (const elem of localStorageKeys) {
    if (localStorage.getItem(elem)) localStorage.removeItem(elem)
  }

  const sessionStorageKeys = [
    'session_id',
    'campaign',
    'campaignUrl',
    'point_id_token_selection',
    'point_id_qr',
    'point_id_geolocation'
  ]
  for (const elem of sessionStorageKeys) {
    if (sessionStorage.getItem(elem)) sessionStorage.removeItem(elem)
  }
}

const API = axios
export default API
export { mountHeaders, clearAuthUserData }
